(() => {
  const updateHeaderClearance = () => {
    const header = document.querySelector('sticky-header, header.header');
    const headerRect = header?.getBoundingClientRect();
    const clearance = headerRect && headerRect.bottom > 0
      ? Math.max(0, headerRect.bottom)
      : 0;

    document.documentElement.style.setProperty('--mademap-header-clearance', `${clearance}px`);
  };

  const initHeaderClearance = () => {
    updateHeaderClearance();
    window.requestAnimationFrame(updateHeaderClearance);

    if (document.documentElement.dataset.mademapHeaderBound === 'true') return;
    document.documentElement.dataset.mademapHeaderBound = 'true';
    window.addEventListener('resize', updateHeaderClearance, { passive: true });
  };

  const pushEvent = (name, detail = {}) => {
    if (!name) return;
    window.IngenioCRO?.track(name === 'mademap_accessory_add' ? 'mademap_accessory_add_click' : name, detail);
  };

  const initDocumentAnalytics = () => {
    if (document.documentElement.dataset.mademapAnalyticsBound === 'true') return;
    document.documentElement.dataset.mademapAnalyticsBound = 'true';

    document.addEventListener('click', (event) => {
      const element = event.target.closest('[data-mademap-event]');
      if (element) {
        pushEvent(element.dataset.mademapEvent, {
          mademap_product: element.dataset.mademapProduct || '',
          mademap_location: element.dataset.mademapLocation || '',
        });
      }

      const summary = event.target.closest('.mademap-v2__faq summary');
      if (!summary) return;
      window.requestAnimationFrame(() => {
        if (!summary.parentElement?.open) return;
        pushEvent('mademap_faq_open', {
          faq_position: [...document.querySelectorAll('.mademap-v2__faq summary')].indexOf(summary) + 1,
        });
      });
    });
  };

  if (!customElements.get('mademap-product-v2')) {
    customElements.define(
      'mademap-product-v2',
      class MademapProductV2 extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-mademap-variants]')?.textContent || '[]');
          this.variantSelect = this.querySelector('[data-mademap-variant-select]');
          this.variantInput = this.querySelector('.product-variant-id');
          this.price = this.querySelector('[data-mademap-price]');
          this.comparePrice = this.querySelector('[data-mademap-compare-price]');
          this.submit = this.querySelector('[data-mademap-submit]');
          this.submitLabel = this.querySelector('[data-mademap-submit-label]');
          this.addLabel = this.dataset.addLabel || 'Agregar al carrito';
          this.soldOutLabel = this.dataset.soldOutLabel || 'Agotado';

          this.querySelectorAll('[data-mademap-media]').forEach((button) => {
            button.addEventListener('click', () => this.selectMedia(button));
          });

          if (this.variantSelect) {
            this.variantSelect.addEventListener('change', () => this.selectVariant(this.variantSelect.value));
          }

          initHeaderClearance();
        }

        selectMedia(button) {
          const mainImage = this.querySelector('.mademap-v2-product__main-image');
          if (!mainImage || !button.dataset.src) return;
          mainImage.removeAttribute('srcset');
          mainImage.src = button.dataset.src;
          mainImage.alt = button.dataset.alt || '';
          this.querySelectorAll('[data-mademap-media]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            if (active) item.setAttribute('aria-current', 'true');
            else item.removeAttribute('aria-current');
          });
        }

        selectVariant(id) {
          const variant = this.variants.find((item) => String(item.id) === String(id));
          if (!variant) return;
          if (this.variantInput) this.variantInput.value = variant.id;
          if (this.price) this.price.textContent = variant.formattedPrice;
          if (this.comparePrice) {
            const showCompare = Number(variant.compareAtPrice) > Number(variant.price);
            this.comparePrice.hidden = !showCompare;
            this.comparePrice.textContent = showCompare ? variant.formattedCompareAtPrice : '';
          }
          if (this.submit) {
            this.submit.disabled = !variant.available;
            this.submit.setAttribute('aria-disabled', String(!variant.available));
          }
          if (this.submitLabel) {
            this.submitLabel.textContent = variant.available
              ? `${this.addLabel} — ${variant.formattedPrice}`
              : this.soldOutLabel;
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

      }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeaderClearance();
    initDocumentAnalytics();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initHeaderClearance();
  });
})();

